export default __webpack_public_path__ + "static/media/section3-img1.99348861.png";